import React from "react";

function Title() {
  return (
    <div className="title-section">
      <h1>New York Times</h1>
      <p>Your daily news and articles.</p>
    </div>
  );
}

export default Title;
